// client/src/components/common/FloatingActionBar.js
import React from 'react';
import { X, CheckSquare } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const FloatingActionBar = ({ count, onClear, onSelectAll, children }) => {
  const { t } = useTranslation('common');

  if (!count) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-indigo-500 shadow-2xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center gap-3 flex-wrap">
          <div className="flex items-center gap-2 px-3 py-1.5 bg-indigo-50 text-indigo-700 rounded-lg font-medium text-sm">
            <CheckSquare className="w-4 h-4" />
            <span>{count} {t('bulkActions.selected', 'selected')}</span>
          </div>
          {onSelectAll && (
            <button
              onClick={onSelectAll}
              className="text-sm text-indigo-600 hover:text-indigo-800 font-medium"
            >
              {t('bulkActions.selectAll', 'Select All')}
            </button>
          )}
          <div className="flex items-center gap-2 flex-wrap flex-1">
            {children}
          </div>
          <button
            onClick={onClear}
            className="p-2 hover:bg-gray-100 rounded-lg text-gray-500"
            title={t('bulkActions.clearSelection', 'Clear selection')}
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default FloatingActionBar;
